<ng-container *ngIf="requestData">
    <div class="request-details-mobile-block">
        <h4 class="header">Request details</h4>

        <ng-container *ngTemplateOutlet="requestData.badgeRequestType === badgeRequestTypeEnum.Resubmission ? resubmitPhoto : default"></ng-container>

        <div class="tabs d-flex justify-content-flex-start">
            <div
                *ngFor="let tab of tabs"
                class="tab"
                [class.active]="tab.categoryId===requestReasonPayload.reason"
                (click)="pickRequestReason(tab)">
                <img [src]="tab.icon" alt="{{ tab.name }}">
                <div class="tab__info">
                    <div class="tab__info--caption">{{ tab.name }}</div>
                    <div class="tab__info--count">
                        {{ tab.placeholder }}
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="isNoteBlockShown"
            class="note-block">
            <div class="note-block__icon">
                <i class="icon-info"></i>
            </div>
            <div class="note-block__title">
                <ng-container [ngSwitch]="requestReasonPayload.reason">

                    <ng-container *ngSwitchCase="badgeChangeReasonsCategories.BadgeLost">
                        <span>Please, if you find your lost badge, bring it to One Team.</span>
                    </ng-container>

                    <ng-container *ngSwitchCase="badgeChangeReasonsCategories.BadgeStolen">
                        <span>Please, if you find your stolen badge, bring it to One Team.</span>
                    </ng-container>

                    <ng-container *ngSwitchCase="badgeChangeReasonsCategories.BadgeDamaged">
                        <span>Please, return your damaged badge to One Team.</span>
                    </ng-container>

                </ng-container>
            </div>
        </div>

        <!--        <ng-container *ngIf="(!requestData.preferredFullname || requestData.fullname===requestData.preferredFullname) else preferredFullName">-->
        <ng-container>
            <div><b>Employee name</b></div>
            <div>{{requestData.fullname}}</div>
        </ng-container>
        <ng-template #preferredFullName>
            <div class="preferred-name">
                <b>Preferred name</b>
                <span>Choose one of the proposed variants which will be displayed on a badge</span>
                <label class="pt-2 pb-1">
                    <input
                        type="radio"
                        id="fullname"
                        name="fullname"
                        [value]="requestData.fullname"
                        (change)="onChangeName(false)"
                        [checked]="isFullNameChecked">
                    <span></span> {{requestData.fullname}}
                </label>
                <label>
                    <input
                        type="radio"
                        id="preferredFullName"
                        name="fullname"
                        [value]="requestData.preferredFullname"
                        (change)="onChangeName(true)"
                        [checked]="!isFullNameChecked">
                    <span></span> {{requestData.preferredFullname}}
                </label>
            </div>
        </ng-template>

        <div class="details-block">
            <b>Delivery location</b>
            <div class="dropdown-block">
                <span class="dropdown-block__title">Deloitte location where badge can be picked up</span>

                <div class="head" (click)="toggle()">
                    <span>{{requestReasonPayload.deliverySiteName || 'Select Location'}}</span>
                    <i class="icon-arrow-expand arrow-icon" [ngClass]="{'opened': isLocationDropdownOpen}"></i>
                </div>
                <div *ngIf="isLocationDropdownOpen" class="list">
                    <div class="search-wrapper">
                        <div class="search-section">
                            <input type="text"
                                   [(ngModel)]="filterQuery"
                                   (ngModelChange)="setFilterQuery($event)"
                                   placeholder="Search"
                                   maxlength="50"
                                   (focus)="$event.stopPropagation()"
                                   (click)="$event.stopPropagation()">
                            <i class="icon-search"></i>
                            <button id="clear-filter-search"
                                    appTrackClickButton
                                    type="button"
                                    class="icon-cross_16px clear-control"
                                    [hidden]="!filterQuery.length"
                                    (click)="$event.stopPropagation(); setFilterQuery('')">
                            </button>
                        </div>
                    </div>

                    <ng-container *ngTemplateOutlet="hasFilteredResults ? optionsList : emptyList"></ng-container>

                    <ng-template #optionsList>
                        <div class="options-wrapper">
                            <div *ngFor="let option of requestData.sites | listFilter: filterBy : false"
                                 class="option"
                                 (click)="locationChanged(option); toggle()">

                                <label>
                                    <span [innerHTML]="option.siteName | htmltransfrom | highlight: pipeFilterQuery"></span>
                                </label>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template #emptyList>
                        <div class="options-empty">No records found</div>
                    </ng-template>
                </div>

            </div>

            <!-- <div *ngIf="requestData.isBloodGroupRequired" class="blood-group">
                <b>Blood group</b>
                    <ui-dropdown-simple
                        [keyName]="'bloodGroupName'"
                        [valueName]="'bloodGroupId'"
                        [optionsList]="requestData.bloodGroups"
                        [selectedValue]="selectedBloodType"
                        [placeholder]="'Select one'"
                        [showListOnTop]="true"
                        (valueChange)="onBloodGroupChange($event)">
                    </ui-dropdown-simple>
            </div> -->
        </div>
    </div>
</ng-container>

<ng-template #default>
    <div class="warning-block">
        <div class="warning-block__icon">
            <i class="icon-exclamation_mark_circled"></i>
        </div>
        <div class="warning-block__title">
            <span>This application should not be used for request of a temp badge.</span>
        </div>
    </div>

    <div><b>Select reason for request</b></div>
</ng-template>

<ng-template #resubmitPhoto>
    <div class="warning-block resubmit-photo">
        <div class="warning-block__icon">
            <i class="icon-info"></i>
        </div>
        <div class="warning-block__title">
            <span>Please recheck the request details below, update it if needed and click the “Next” button in the right bottom corner to continue.</span>
        </div>
    </div>

    <div><b>Badge request reason</b></div>
</ng-template>
